import React from 'react';
import Modal from '../Modal';
import styles from './RecordingOnWebModal.module.scss';
import { useTranslation } from 'react-i18next';
import CloseButton from '../CloseButton/CloseButton';

export const RecordingOnWebModal = ({ show, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal className={styles.modal} onClose={onClose} open={show}>
      <div className={styles.content}>
        <div className={styles.header}>{t('home_page.recording_request')}</div>
        <CloseButton onClose={onClose} />
      </div>
      <span className={styles.text}>{t('home_page.recording_request.mobile_modal.text')}</span>
    </Modal>
  );
};
